import { CountrySelectionState, SelectedCountries, CountryMap, CountrySelection } from "app/pages/DiscountEditor/modules/CountrySelection/state";
import { Country } from "app/shared/model";
import { CountryFilerDto } from "app/shared/model/DiscountDto";
import { CountrySelectionMode } from "app/shared/model/CountrySelectionMode";

function getRoot(state: any) : CountrySelectionState {
    return state.countrySelection;
}

export function getCountrySelectionMode(state: any) : CountrySelectionMode {
    return getRoot(state).selectionMode;
}

export function getSelectedCountries(state: any) : CountrySelection[] {
    const map = getRoot(state).selectedCountries;
    return Object.keys(map).map(v => map[v]);
}

export function getCountries(state: any) : Country[] {
    const root = getRoot(state);
    return Object.keys(root.countryMap).map(c => 
        root.countryMap[c]
    );
}

export function getCountryFilterDto(state: any) : CountryFilerDto {
    const root = getRoot(state);
    return {
        selectionMode: root.selectionMode,
        countries: root.selectionMode === CountrySelectionMode.AllCountries
            ? []
            : getSelectedCountries(state).filter(x => x.selected).map(x => x.id)
    }
}